
import "@sparta.global.modules/get-app-modal-module/dist/styles.css"
import "@sparta.auto-loans.modules/rates-engagement-auto-module/dist/styles.css"
import "@sparta.auto-loans.modules/get-prequalified-module/dist/styles.css"
import "@sparta.auto-loans.modules/two-column-content-header-module/dist/styles.css"
import "@sparta.auto-loans.modules/jumbotron-list-3-steps-auto-module/dist/styles.css"
import "@sparta.auto-loans.modules/dealer-locator-auto-module/dist/styles.css"
import "@sparta.auto-loans.modules/two-column-content-auto-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import ampTriggerVideoUtility from "@sparta.global.utilities/amp-trigger-video-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaRegisterSwUtility from "@sparta.global.utilities/sparta-register-sw-utility/dist/es6.js"
import cspStyleBinder from "@sparta.sales.utilities/csp-style-binder/dist/es6.js"

import "@sparta.global.modules/get-app-modal-module/dist/es6.js"
import "@sparta.auto-loans.modules/rates-engagement-auto-module/dist/es6.js"
import "@sparta.auto-loans.modules/get-prequalified-module/dist/es6.js"
import "@sparta.auto-loans.modules/two-column-content-header-module/dist/es6.js"
import "@sparta.auto-loans.modules/jumbotron-list-3-steps-auto-module/dist/es6.js"
import "@sparta.auto-loans.modules/dealer-locator-auto-module/dist/es6.js"
import "@sparta.auto-loans.modules/two-column-content-auto-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  secureLinkUtility.run()
await spartaBootstrapUtility.init(arguments);
spartaRegisterSwUtility.init();
cspStyleBinder.bindStyle();
  console.log('after - execute boot functions')
})();
